import React from "react";
import { CommonProps } from "@front/fds2.0-green/dist/src/helpers/props";

export interface IProps extends CommonProps {
  stroke?: string;
  width?: string | number | undefined;
  height?: string | number | undefined;
}
const AiChatStopIcon: React.FC<IProps> = ({
  classes,
  stroke,
  width,
  height,
}) => {
  return (
    <svg
      width={width || "32"}
      height={height || "32"}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="4.8"
        y="4.8"
        width="22.4"
        height="22.4"
        rx="11.2"
        stroke="#25C16F"
        stroke-width="1.6"
      />
      <rect x="12" y="11.9999" width="8" height="8" rx="1" fill="#25C16F" />
    </svg>
  );
};

export default AiChatStopIcon;
